import NewsDisplay from './NewsDisplay'

export default NewsDisplay